import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class ProductDiamondCarat extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {
      expanded: false,
    };

    console.log(this.props);
	}

	componentDidMount() {

  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  toggleExpanded() {
    this.setState({ expanded: !this.state.expanded });
  }

  getDiamondUrl() {

    if(!this.props.shape) {
      return '';
    }

    switch(this.props.shape) {
      case 'Round':
        return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/round.svg';
      case 'Princess':
        return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/princess.svg';
      case 'Cushion':
        return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/cushion.svg';
      case 'Emerald':
        return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/emerald.svg';
      case 'Radiant':
        return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/radiant.svg';
      case 'Oval':
        return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/oval.svg';
      case 'Pear':
        return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/pear.svg';
      case 'Asscher':
        return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/asscher.svg';
      case 'Marquise':
        return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/marquis.svg';
      default:
        return 'https://ddw2.diamondsdirect.com/img/productpage/caratguide/diamonds/round.svg';
    }
  }

  getSliderOffset() {
    if(this.props.carat_weight >= 5) {
      return '100';
    } else {
      let rangeSpan = 5 - 0.2;
      let percent = (this.props.carat_weight / rangeSpan) * 100;
      return percent.toString() + '%';
    }
  }

  getDiamondSize() {

    // Image size: 600x700px;
    // Ring diameter: 12px;

    // let bandWidth = 1.8mm;
    // let oneCtWidth = 6.5mm;

    // d = 6.5(cw)^1.5

    // 6.5 = a(cw)^(2/3)

    // 2r

    // 4/3 pi r^3 = cw


    // 0.75*cw = pi r^3

    // 2(0.25*cw)^1/3 = 2r


    let widthMM = 6.25 * Math.pow(this.props.carat_weight, 0.33333333);

    // 1mm = 1.1111111%    
    return (widthMM * 1.11111).toString() + '%';
  }

  getDiamondRadius() {
    let widthMM = 6.25 * Math.pow(this.props.carat_weight, 0.33333333);
    return ((widthMM * 1.11111)/2).toString() + '%';
  }

	render() {

    if(!this.props.shape || !this.props.carat_weight) {
      return null;
    }

		return <div className='ProductDiamondCarat'>
			<div className='caratHeader' onClick={::this.toggleExpanded}>
        <div className='headerLabel'>Diamond Carat Size Guide</div>
        {this.state.expanded ?
          <div className='headerIcon'>&mdash;</div> :
          <div className='headerIcon'>+</div>
        }
      </div>
      <div className={this.state.expanded ? 'caratBodyWrapper expanded' : 'caratBodyWrapper'}>
        <div className='handSection'>
          <div className='handImgWrapper'>
            <img src='https://ddw2.diamondsdirect.com/img/productpage/caratguide/hand_2.svg' />
            <div 
              className='diamondImgWrapper' 
              style={{
                width: this.getDiamondSize(), 
                height: this.getDiamondSize(),
                top: 'calc(55.0% - ' + this.getDiamondRadius() + ')',
                left: 'calc(36% - ' + this.getDiamondRadius() + ')',
              }}>
              <img src={this.getDiamondUrl()} />
            </div>
          </div>
        </div>
        <div className='sliderSection'>
          <div className='caratSliderWrapper'>
            <div className='caratSliderTrack'></div>
            <div className='caratSliderElement' style={{left: this.getSliderOffset()}}></div>
          </div>
          <div className='caratSliderLabelWrapper'>
            <div className='labelLeft'>0.2 Ct</div>
            <div className='labelCurrent' style={{left: 'calc(' + this.getSliderOffset() + ' - 20px)'}}>{this.props.carat_weight + ' Ct'}</div>
            <div className='labelRight'>5 Ct</div>
          </div>
          <div className='caratTextWrapper'>
            <div className='caratText'>Diamond carat weight is the measurement of how much a diamond weighs. A metric “carat” is defined as 200 mg. Each carat can be subdivided into 100 points. This allows very precise measurements.</div>
          </div>
        </div>
      </div>
		</div>;
	}
}
export default ProductDiamondCarat;

function mapStateToProps(state) {
  return {

  };
}

export const ProductDiamondCaratContainer = connect(
  mapStateToProps,
  allActionCreators
)(ProductDiamondCarat);


// WEBPACK FOOTER //
// ./src/components/views/product-page/blocks/ProductDiamondCarat.jsx